import { render, staticRenderFns } from "./Korisnici.vue?vue&type=template&id=209d391c&scoped=true"
import script from "./Korisnici.vue?vue&type=script&lang=js"
export * from "./Korisnici.vue?vue&type=script&lang=js"
import style0 from "./Korisnici.vue?vue&type=style&index=0&id=209d391c&prod&lang=css"
import style1 from "./Korisnici.vue?vue&type=style&index=1&id=209d391c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209d391c",
  null
  
)

export default component.exports